import "./Entry.css"

export default function Entry() {
  return (
    <div className="entries-placeholder">
      <h2>Coming Soon 建設中</h2>
      <p>Please look forward to a new blog post here in November!</p>
    </div>
  )
}
